export default "__VITE_ASSET__DlhsJjkE__"